
import { Component, h } from 'preact';
import cx from 'classnames';
import moment from 'moment-timezone';

import getStore from '../../store';
import * as InquiriesActions from '../../reducers/inquiries/inquiries.actions';

import { Comment } from '../../../../types/comment.model';
import { Inquiry } from '../../../../types/inquiries';
import { Permission } from '../../../../types/permission.model';

import CommentService from '../../../utils/comment.service';
import { Formats } from '../../../../constants/api';
import { HopplerModalizer } from '../common/hoppler-modalizer.component';

interface CommentsModalProps {
  keycode?: string;
  permissionComments?: Permission
  onClose?: () => void;
  type?: string;

  incrementCommentCount?: (key: string) => void;
}

interface CommentsModalState {
  comments?: Comment[];
  commentBody?: string;
  isFetching?: boolean;
  isPosting?: boolean;
  hasError?: boolean;
}

const store = getStore();

export class CommentsModal extends Component<CommentsModalProps, CommentsModalState> {

  constructor(props) {
    super(props);

    this.state = {
      isFetching: false,
      isPosting: false,
      hasError: false,
      comments: [],
    }
  }

  doModalClose = () => {}

  componentDidMount() {
    this.getComments();
  }

  addComment = async () => {
    if (!this.state.commentBody) {
      return this.setState({ hasError: true })
    }

    try {
      this.setState({ isPosting: true })
      const keycode = this.props.keycode;
      
      const res = await CommentService.addComment(keycode, this.state.commentBody, this.props.type);
      
      this.setState({ 
        isPosting: false,
        commentBody: ""
      });
      this.getComments();

      if (this.props.type === 'inquiry') {
        // We can get away with this because the LOAD_COMMENTS action only needs
        // the inquiry code
        const miniInq: Inquiry = { inquiryCode: this.props.keycode };
        store.dispatch({ type: InquiriesActions.LOAD_COMMENTS, payload: { selectedInquiry: miniInq } });
      }

      if (this.props.incrementCommentCount) {
        this.props.incrementCommentCount(this.props.keycode);
      }
    } catch (error) {
      console.error(error);
    }
  }

  handleChange = (e) => {
    const value = e.target.value;
    this.setState({ commentBody: value })
  }

  getComments = async () => {
    this.setState({ isFetching: true })
    try {
      const keycode = this.props.keycode;
      const res = await CommentService.getComments(keycode, this.props.type)
      
      this.setState({
        comments: res.data.results,
        isFetching: false
      })

    } catch (error) { 
      console.log(error)
      this.setState({ isFetching: false })
    }
  }

  getCommentBlock(props: CommentsModalProps, state: CommentsModalState) {
    const count = state.comments.length;
    if (count > 0) {
      return (
        state.comments.map((comment, i) => (
          <div
            key={ i } 
            className={ cx("hi-comments-modal__comment-list-row", {
            'border-bottom-0': i + 1 == count
          }) }>
            <div className="d-flex align-items-center">
              <p className="mb-0 font-weight-bold">{ comment.fullName }</p>
              <span className="mx-1 text-muted">-</span>
              <p className="mb-0 text-muted">{ moment(comment.dateCreated).format(Formats.date) }</p>
            </div>
            <p className="mb-0">{ comment.comment }</p>
          </div>
        ))
      );
    } else {
      return <p>No comments found.</p>;
    }
  }

  getSpinnerBlock() {
    return(
      <div className="hi-comments-modal__comment-list-spinner">
        <div className="d-flex align-items-center justify-content-center">
          <div className="spinner-border spinner-border-sm" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <p className="mb-0 ml-1">Loading</p>
        </div>
      </div>
    )
  }

  render(props: CommentsModalProps, state: CommentsModalState) {
    return (
      <HopplerModalizer onClose={ () => null }>
        <div className="hi-modal hi-comments-modal px-0">
          <div className="hi-modal__title-bar">
            <span className="hi-modal__title-label">
              <i className="fas fa-comment-alt mr-2"></i>
              Comments
            </span>
            <button className="btn btn-link hi-modal__title-close" onClick={ props.onClose }>
              <i className="fas fa-times" />  Close
            </button>
          </div>
          <div className="hi-modal__body hi-comments-modal__body">
            <div className="hi-comments-modal__comment-list">
              {
                state.isFetching 
                  ? this.getSpinnerBlock()
                  : this.getCommentBlock(props, state)
              }
            </div>

            <div className="hi-comments-modal__form">
              <textarea 
                className={ cx('form-control', {
                  'invalid': state.hasError && !state.commentBody
                })}
                rows={ 3 }
                value={ this.state.commentBody }
                onChange={ e => this.handleChange(e) }
                name="comment-input"
                placeholder="Write new comment here">
              </textarea>

              {
                state.hasError && !state.commentBody ? (
                  <small className="text-danger">
                    <i className="fas fa-exclamation-circle mr-1"></i>
                    Please provide a comment.
                  </small>
                ) : null
              }

              <div className="d-flex justify-content-center hi-my-10 mb-0">
                <button
                  disabled={ state.isPosting }
                  type="button"
                  onClick={ this.addComment } 
                  className="btn btn-secondary hi-form-button">
                  { state.isPosting ? 'Adding...' : 'Add' }
                </button>
              </div>
            </div>
            
          </div>
        </div>  
      </HopplerModalizer>
    );
  }
}